module.exports = __webpack_public_path__ + "img/实验室爆炸.ec3f0535.jpg";